// extracted by mini-css-extract-plugin
export default {"cell":"TableRowDecorator_cell__kg1Ix","pill":"TableRowDecorator_pill__C+VMh"};